export interface HeapEntry<T> { at: number; seq: number; value: T; }

/** Binary min-heap keyed by (at, seq) — same-instant timers fire in insertion order. */
export class TimerHeap<T> {
  private a: HeapEntry<T>[] = [];
  get size(): number { return this.a.length; }
  peek(): HeapEntry<T> | undefined { return this.a[0]; }
  /** Unordered view of live entries (for bookkeeping like pendingCount). */
  *entries(): IterableIterator<HeapEntry<T>> { yield* this.a; }
  push(e: HeapEntry<T>): void {
    this.a.push(e);
    let i = this.a.length - 1;
    while (i > 0) {
      const p = (i - 1) >> 1;
      if (this.less(i, p)) { this.swap(i, p); i = p; } else break;
    }
  }
  pop(): HeapEntry<T> | undefined {
    const top = this.a[0];
    const last = this.a.pop();
    if (this.a.length > 0 && last !== undefined) {
      this.a[0] = last;
      let i = 0;
      for (;;) {
        const l = 2 * i + 1, r = l + 1;
        let m = i;
        if (l < this.a.length && this.less(l, m)) m = l;
        if (r < this.a.length && this.less(r, m)) m = r;
        if (m === i) break;
        this.swap(i, m); i = m;
      }
    }
    return top;
  }
  private less(i: number, j: number): boolean {
    return this.a[i].at < this.a[j].at || (this.a[i].at === this.a[j].at && this.a[i].seq < this.a[j].seq);
  }
  private swap(i: number, j: number): void { [this.a[i], this.a[j]] = [this.a[j], this.a[i]]; }
}
